module.exports = __webpack_public_path__ + "img/icon_likes.6160380d.png";